import { AnyAction, AsyncThunkAction, Dispatch } from "@reduxjs/toolkit";
import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";
import type { AppDispatch, RootState } from "./store";

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatchCaller = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

declare type AsyncThunkConfig = {
    state?: unknown;
    dispatch?: Dispatch;
    extra?: unknown;
    rejectValue?: unknown;
    serializedErrorType?: unknown;
    pendingMeta?: unknown;
    fulfilledMeta?: unknown;
    rejectedMeta?: unknown;
};

export const useAppDispatch = () => {
    const dispatch = useDispatch<AppDispatch>();

    function dispatchAction<TReturn, TArg>(action: AsyncThunkAction<TReturn, TArg, AsyncThunkConfig>): Promise<TReturn>;
    function dispatchAction<TReturn, TArg>(action: AnyAction): void;
    function dispatchAction<TReturn, TArg>(action: AsyncThunkAction<TReturn, TArg, AsyncThunkConfig> | AnyAction): Promise<TReturn> | void {
        if (action.name !== undefined) { //Anything with a then after it, has a blank name, anything that returns void will be undefined
            return dispatch(action).unwrap();
        } else {
            dispatch(action);
        }
    }

    return dispatchAction;
};

// Experiement to see if we can get the dispatch to work with a generic type For the State, Action parameters on the reducers
export interface ReducerActionType<T>{
    payload: {
        key: keyof T;
        value: any;
    };
    type: string;
}



















// export function UseAppDispatcher() {

//     class UseUnwrappedDispatch {
//         constructor() {
//             console.log("UseUnwrappedDispatch constructor");
//         }
        
//         dispatchAction<TReturn, TArg>(action: AsyncThunkAction<TReturn, TArg, AsyncThunkConfig>): Promise<TReturn>;
//         dispatchAction<TReturn, TArg>(action: AnyAction): void;
//         dispatchAction<TReturn, TArg>(action: AsyncThunkAction<TReturn, TArg, AsyncThunkConfig> | AnyAction): Promise<TReturn> | void {
//             if (action as AnyAction != undefined){
//                 useDispatch<AppDispatch>()(action);
//             } else {
//                 return useDispatch<AppDispatch>()(action).unwrap();
//             }
//         }
//     };
    
    
//     const useAppDispatch = () => (new UseUnwrappedDispatch()).dispatchAction;
// }


// export class UseUnwrappedDispatch {
//     constructor() {
//         console.log("UseUnwrappedDispatch constructor");
//     }
    
//     dispatchAction<TReturn, TArg>(action: AsyncThunkAction<TReturn, TArg, AsyncThunkConfig>): Promise<TReturn>;
//     dispatchAction<TReturn, TArg>(action: AnyAction): void;
//     dispatchAction<TReturn, TArg>(action: AsyncThunkAction<TReturn, TArg, AsyncThunkConfig> | AnyAction): Promise<TReturn> | void {
//         if (action as AnyAction != undefined){
//             useDispatch<AppDispatch>()(action);
//         } else {
//             return useDispatch<AppDispatch>()(action).unwrap();
//         }
//     }
// };


// export const useAppDispatch = () => (new UseUnwrappedDispatch()).dispatchAction;
 

// export const useAppDispatch = () => <T>(action: UseUnwrappedDispatch<T extends AsyncThunkConfig>) => action()
// export const useAppDispatch = () => <TReturn, TArg>(action: AsyncThunkAction<TReturn, TArg, AsyncThunkConfig> | 
//                                                                    AnyAction) : Promise<TReturn> | void => {
    
//     const tt = action as AsyncThunkAction<TReturn, TArg, AsyncThunkConfig>;
//     if (typeof tt === 'function') {
//         return useDispatch<AppDispatch>()(tt).unwrap();
//     } else {
//         return useDispatch<AppDispatch>()(tt);
//     }
// } 


// export const useAppDispatch = () => <TReturn, TArg>(action: AsyncThunkAction<TReturn, TArg, AsyncThunkConfig> | 
//                                                                    AnyAction) : Promise<TReturn> | void => {
//     const tt = action as AsyncThunkAction<TReturn, TArg, AsyncThunkConfig>;
//     if (typeof tt === 'function') {
//         return useDispatch<AppDispatch>()(tt).unwrap();
//     } else {
//         return useDispatch<AppDispatch>()(tt);
//     }
// } 


// export function useUnwrappedAppDispatch<ReturnType, FirstParamType, V extends AsyncThunkConfig>(action: AsyncThunk<ReturnType, FirstParamType, V>) {
//     const dispatch = useAppDispatch();
//     return dispatch(action).unwrap();
// }